import React, { Component, PropTypes } from 'react';

class Chip extends Component {

    static propTypes = {
        /**
         * If show a close icon
         * @default false
         */
        close: PropTypes.bool,

        children: PropTypes.node
    };

    render() {
        let close = '';
        if (this.props.close) {
            close = <i className="material-icons">close</i>;
        }

        return (
            <div className="chip">
                {this.props.children}
                {close}
            </div>
        );
    }
}

export default Chip;